module.exports = __webpack_public_path__ + "media/images/desktop/more-ea381f33dcbbd7ccf96e2c5e22f36285.svg";